module.exports = __webpack_public_path__ + "static/media/sample_certificate_image_male.a0dbf09b.png";